import { StyleSheet, Dimensions } from 'react-native';

import { isIPhoneDeviceWithNotch } from '@vfgroup-oneplatform/foundation/Utils/Platform';

import { TRAY_TYPES } from '../Utils/TrayTypesConstants';

const isIPhoneWithNotch = isIPhoneDeviceWithNotch();

const traySecondLevelStyle = type =>
  type === TRAY_TYPES.SECONDLEVEL && {
    height: Dimensions.get('window').height,
    ...StyleSheet.absoluteFill,
  };
export default StyleSheet.create({
  container: type => ({
    flex: 1,
    ...traySecondLevelStyle(type),
  }),
  trayViewContainer: {
    position: 'absolute',
    bottom: isIPhoneWithNotch ? -10 : 0,
  },
});
